import {Injectable} from "@angular/core";

interface ScriptDetail {
    name: string;
    src: string;
}  


declare var document: any;

@Injectable()
export class ScriptService {

private scripts: any = {};

constructor() {
    /*ScriptStore.forEach((script: any) => {
        this.scripts[script.name] = {
            loaded: false,
            src: script.src
        };
    });*/
}

/*load(script: ScriptDetail) {
    var promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
}*/

public loadScript(script: ScriptDetail) {
    return new Promise((resolve, reject) => {
        //resolve if already loaded
        if (this.scripts[script.name] == null){
            this.scripts[script.name] = script;
        }
        if (this.scripts[script.name].loaded) {
            resolve({script: script.name, loaded: true, status: 'Already Loaded'});
        }
        else {
            //load script
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = script.src;
            if (script.readyState) {  //IE
                script.onreadystatechange = () => {
                    if (script.readyState === "loaded" || script.readyState === "complete") {
                        script.onreadystatechange = null;
                        this.scripts[script.name].loaded = true;
                        resolve({script: script.name, loaded: true, status: 'Loaded'});
                    }
                };
            } else {  //Others
                script.onload = () => {
                    this.scripts[script.name].loaded = true;
                    resolve({script: script.name, loaded: true, status: 'Loaded'});
                };
            }
            script.onerror = (error: any) => resolve({script: script.name, loaded: false, status: 'Loaded'});
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    });
}

}